export default __webpack_public_path__ + "static/media/arrow-left.0dbe7f13.svg";